(function() {
  'use strict';

  // ── STATE ──────────────────────────────────────
  let currentStep = 0;
  const totalSteps = 8;

  const answers = {
    skinType: null,
    concerns: [],
    faceZone: [],
    lifestyleWater: null,
    lifestyleOutdoor: null,
    lifestyleStress: null,
    lifestyleSleep: null,
    age: null,
    visualHydration: null,
    visualTexture: null,
    visualTone: null,
    ingredientsAvoid: [],
    ingredientsLike: [],
    name: '',
    email: ''
  };

  const ritualCart = new Set();
  let ritualTotal = 0;

  // ── PRODUCT DATABASE ───────────────────────────
  const products = {
    cleansing_oil: {
      name: 'Aceite Limpiador',
      benefit: 'Disuelve maquillaje y protector sin resecar, con aceites botánicos.',
      price: 24.99
    },
    luna_glow: {
      name: 'Luna Glow',
      benefit: 'Limpieza profunda con enzimas naturales que iluminan el tono.',
      price: 26.99
    },
    rose_tonic: {
      name: 'Tónico de Rosas',
      benefit: 'Equilibra el pH y prepara la piel para absorber activos.',
      price: 19.99
    },
    vitamin_c_serum: {
      name: 'Sérum Vitamina C',
      benefit: 'Antioxidante que unifica el tono y protege del daño ambiental.',
      price: 31.99
    },
    hyaluronic_serum: {
      name: 'Ácido Hialurónico',
      benefit: 'Hidratación profunda con ácido hialurónico de triple peso molecular.',
      price: 29.99
    },
    anti_aging_serum: {
      name: 'Suero Anti-Edad',
      benefit: 'Colágeno, ácido hialurónico y vitamina C para firmeza y líneas finas.',
      price: 38.99
    },
    clarify_serum: {
      name: 'Clarify Serum',
      benefit: 'Niacinamida y extractos botánicos para un tono más uniforme.',
      price: 34.99
    },
    turmeric_mask: {
      name: 'Mascarilla de Cúrcuma',
      benefit: 'Cúrcuma orgánica y miel para calmar y purificar la piel.',
      price: 28.99
    },
    black_soap: {
      name: 'Black Soap',
      benefit: 'Jabón ancestral que purifica sin agredir la barrera cutánea.',
      price: 14.99
    },
    face_cream: {
      name: 'Crema Rejuvenecedora',
      benefit: 'Nutrición con rosa mosqueta y manteca de karité orgánica.',
      price: 44.99
    },
    eye_cream: {
      name: 'Contorno de Ojos',
      benefit: 'Vitamina C, retinol y niacinamida para el contorno más delicado.',
      price: 39.99
    },
    sunscreen: {
      name: 'Bloqueador Solar SPF 50',
      benefit: 'Protección solar mineral con zinc y antioxidantes naturales.',
      price: 34.99
    },
    turmeric_bar: {
      name: 'Jabón de Cúrcuma',
      benefit: 'Detoxifica, unifica el tono y rejuvenece la piel sensible.',
      price: 16.99
    },
    calming_serum: {
      name: 'Sérum Calmante',
      benefit: 'Centella asiática y aloe vera para pieles reactivas.',
      price: 38.99
    },
    elixir_divino: {
      name: 'Elixir Divino',
      benefit: 'Aceite facial multifuncional con rosa mosqueta y aceites esenciales.',
      price: 34.99
    },
    natural_deodorant: {
      name: 'Desodorante Natural de Lavanda',
      benefit: 'Sin aluminio ni químicos. Protección natural todo el día.',
      price: 18.99
    },
    glycolic_acid: {
      name: 'Ácido Glicólico',
      benefit: 'Exfoliante químico con ácidos frutales que renueva y unifica el tono.',
      price: 29.99
    },
    kit_7: {
      name: 'Kit 7 Pasos',
      benefit: 'Tu ritual completo de mañana y noche.',
      price: 119.99
    }
  };

  // Precios reales de Shopify (sections/tm-skin-analysis.liquid); los de arriba quedan solo como respaldo
  Object.keys(products).forEach((clave) => {
    const precio = (window.tmQuizPrecios || {})[clave];
    if (typeof precio === 'number') products[clave].price = precio;
  });

  // ── NAVIGATION ─────────────────────────────────
  function updateUI() {
    const nav = document.getElementById('quizNav');
    const track = document.getElementById('progressTrack');
    const counter = document.getElementById('stepCounter');
    const fill = document.getElementById('progressFill');
    const back = document.getElementById('btnBack');

    // La barra (con el botón cerrar) siempre visible: nunca quedarse sin salida
    nav.classList.remove('hidden');
    if (currentStep === 0 || currentStep === 'results') {
      track.style.display = 'none';
      if (back) back.style.visibility = 'hidden';
      counter.textContent = currentStep === 'results' ? 'Tu ritual' : '';
    } else {
      track.style.display = 'block';
      if (back) back.style.visibility = '';
      counter.textContent = `Paso ${currentStep} de ${totalSteps}`;
      fill.style.width = `${(currentStep / totalSteps) * 100}%`;
    }
  }

  window.goToStep = function(step) {
    const current = document.querySelector('.step.active');
    if (current) {
      current.classList.add('exit-left');
      current.classList.remove('active');
    }

    currentStep = step;

    setTimeout(() => {
      if (current) {
        current.classList.remove('exit-left');
      }

      const next = document.querySelector(`.step[data-step="${step}"]`);
      if (next) {
        next.classList.add('active');
        next.scrollTop = 0;
        window.scrollTo(0, 0);
      }
      updateUI();
    }, 50);
  };

  window.goBack = function() {
    if (currentStep <= 1) {
      goToStep(0);
      return;
    }
    const current = document.querySelector('.step.active');
    if (current) {
      current.style.transform = 'translateX(60px)';
      current.style.opacity = '0';
      current.classList.remove('active');
    }

    currentStep = currentStep - 1;

    setTimeout(() => {
      if (current) {
        current.style.transform = '';
        current.style.opacity = '';
      }
      const prev = document.querySelector(`.step[data-step="${currentStep}"]`);
      if (prev) {
        prev.style.transform = 'translateX(-60px)';
        prev.classList.add('active');
        requestAnimationFrame(() => {
          prev.style.transform = '';
          window.scrollTo(0, 0);
        });
      }
      updateUI();
    }, 50);
  };

  window.closeQuiz = function() {
    const vieneDeLaTienda = document.referrer && document.referrer.indexOf(window.location.origin) === 0;
    if (vieneDeLaTienda && window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }
  };

  // ── CARD SELECTION (SINGLE) ────────────────────
  window.selectCard = function(el, key) {
    if (el.classList.contains('disabled')) return;

    const grid = el.parentElement;
    grid.querySelectorAll('.card').forEach(c => c.classList.remove('selected'));
    el.classList.add('selected');
    answers[key] = el.dataset.value;

    // Enable next button
    const stepNum = el.closest('.step').dataset.step;
    const btn = document.getElementById('btnStep' + stepNum);
    if (btn) btn.disabled = false;
  };

  // ── CONCERN TOGGLE (MULTI-SELECT up to 3) ──────
  window.toggleConcern = function(el) {
    const maxSelections = 3;

    if (el.classList.contains('selected')) {
      el.classList.remove('selected');
    } else {
      const selected = document.querySelectorAll('#concernsGrid .card.selected');
      if (selected.length >= maxSelections) return;
      el.classList.add('selected');
    }

    const selectedCards = document.querySelectorAll('#concernsGrid .card.selected');
    answers.concerns = Array.from(selectedCards).map(c => c.dataset.value);

    const btn = document.getElementById('btnStep2');
    if (btn) btn.disabled = answers.concerns.length === 0;
  };

  // ── FACE ZONE TOGGLE (MULTI-SELECT up to 2) ────
  window.toggleFaceZone = function(el) {
    const maxSelections = 2;
    const grid = document.getElementById('faceZoneGrid');

    if (el.dataset.value === 'sin_zona') {
      grid.querySelectorAll('.card').forEach(c => c.classList.remove('selected'));
      el.classList.add('selected');
      answers.faceZone = ['sin_zona'];
    } else {
      // Deselect "sin_zona" if another option is picked
      grid.querySelector('[data-value="sin_zona"]').classList.remove('selected');

      if (el.classList.contains('selected')) {
        el.classList.remove('selected');
      } else {
        const selected = grid.querySelectorAll('.card.selected');
        if (selected.length >= maxSelections) return;
        el.classList.add('selected');
      }

      const selectedCards = grid.querySelectorAll('.card.selected');
      answers.faceZone = Array.from(selectedCards).map(c => c.dataset.value);
    }

    const btn = document.getElementById('btnStep3');
    if (btn) btn.disabled = answers.faceZone.length === 0;
  };

  // ── PILL SELECTION (SINGLE within group) ───────
  window.selectPill = function(el, groupId) {
    const group = document.getElementById(groupId);
    group.querySelectorAll('.pill').forEach(p => p.classList.remove('selected'));
    el.classList.add('selected');
    answers[groupId] = el.dataset.value;

    // Check step 4 (lifestyle) completion
    if (groupId.startsWith('lifestyle')) {
      const allDone = answers.lifestyleWater && answers.lifestyleOutdoor && answers.lifestyleStress && answers.lifestyleSleep;
      const btn = document.getElementById('btnStep4');
      if (btn) btn.disabled = !allDone;
    }
  };

  // ── PILL TOGGLE (MULTI-SELECT) ─────────────────
  window.togglePill = function(el, groupId) {
    el.classList.toggle('selected');
    const selected = [];
    document.getElementById(groupId).querySelectorAll('.pill.selected').forEach(p => {
      selected.push(p.dataset.value);
    });
    answers[groupId] = selected;
  };

  // ── VISUAL BOX SELECTION ───────────────────────
  window.selectVisual = function(el, groupId) {
    const group = document.getElementById(groupId);
    group.querySelectorAll('.visual-box').forEach(b => b.classList.remove('selected'));
    el.classList.add('selected');
    answers[groupId] = el.dataset.value;

    // Check step 6 completion
    const allDone = answers.visualHydration && answers.visualTexture && answers.visualTone;
    const btn = document.getElementById('btnStep6');
    if (btn) btn.disabled = !allDone;
  };

  // ── EMAIL SUBMIT ───────────────────────────────
  window._submitEmail_REPLACED = function() {  // replaced below
    answers.name = document.getElementById('userName').value.trim();
    answers.email = document.getElementById('userEmail').value.trim();
    showResults();
  };

  // ── SHOW RESULTS ───────────────────────────────
  window.showResults = function() {
    try {
      buildResults();
      goToStep('results');
      document.getElementById('stickyBar').classList.add('visible');
    } catch(e) {
      console.error('Error en showResults:', e, e.stack);
      // Aun con un error, mostrar los resultados que se alcanzaron a armar (sin aviso técnico para la clienta)
      goToStep('results');
    }
  };

  // ── RESULTS ENGINE ─────────────────────────────
  function buildResults() {
    // Ensure arrays exist
    if (!answers.concerns) answers.concerns = [];
    if (!answers.faceZone) answers.faceZone = [];
    if (!answers.ingredientsAvoid) answers.ingredientsAvoid = [];
    if (!answers.ingredientsLike) answers.ingredientsLike = [];

    // Summary pills
    const pills = document.getElementById('summaryPills');
    const labels = {
      skinType: { normal:'Normal', seca:'Seca', grasa:'Grasa', mixta:'Mixta', sensible:'Sensible', madura:'Madura', joven:'Joven', no_segura:'Sin definir' },
      concernLabels: { hidratacion:'Hidratación', poros:'Poros', manchas:'Manchas', luminosidad:'Luminosidad', granos:'Granos', rojeces:'Rojeces', lineas:'Anti-edad', firmeza:'Firmeza', flacidez:'Firmeza' },
      climate: {}
    };

    let pillsHTML = '';
    if (answers.skinType && labels.skinType[answers.skinType]) {
      pillsHTML += `<span class="summary-pill">Piel ${labels.skinType[answers.skinType]}</span>`;
    }
    answers.concerns.forEach(c => {
      if (labels.concernLabels[c]) {
        pillsHTML += `<span class="summary-pill">${labels.concernLabels[c]}</span>`;
      }
    });
    pills.innerHTML = pillsHTML;

    // Determine product recommendations based on skin type
    const recommended = [];
    const skin = answers.skinType;
    const concerns = answers.concerns || [];

    if (skin === 'seca' || skin === 'normal' || skin === 'no_segura') {
      recommended.push('cleansing_oil');
      recommended.push('luna_glow');
      recommended.push('rose_tonic');
      recommended.push('vitamin_c_serum');
      recommended.push('anti_aging_serum');
      recommended.push('face_cream');
      recommended.push('eye_cream');
      recommended.push('hyaluronic_serum');
      recommended.push('elixir_divino');

    } else if (skin === 'grasa') {
      recommended.push('black_soap');
      recommended.push('calming_serum');
      recommended.push('hyaluronic_serum');
      recommended.push('vitamin_c_serum');
      recommended.push('rose_tonic');

    } else if (skin === 'mixta') {
      recommended.push('luna_glow');
      recommended.push('rose_tonic');
      recommended.push('vitamin_c_serum');
      recommended.push('hyaluronic_serum');
      recommended.push('face_cream');
      recommended.push('elixir_divino');

    } else if (skin === 'madura') {
      recommended.push('cleansing_oil');
      recommended.push('luna_glow');
      recommended.push('rose_tonic');
      recommended.push('vitamin_c_serum');
      recommended.push('anti_aging_serum');
      recommended.push('face_cream');
      recommended.push('eye_cream');
      recommended.push('hyaluronic_serum');
      recommended.push('elixir_divino');

    } else if (skin === 'joven') {
      recommended.push('luna_glow');
      recommended.push('rose_tonic');
      recommended.push('natural_deodorant');
      recommended.push('elixir_divino');

    } else if (skin === 'sensible') {
      recommended.push('turmeric_bar');
      recommended.push('luna_glow');
      recommended.push('calming_serum');
      recommended.push('eye_cream');
      recommended.push('hyaluronic_serum');
      recommended.push('elixir_divino');
    }

    // Agregar productos según preocupaciones seleccionadas
    const concernProducts = {
      hidratacion: ['hyaluronic_serum'],
      poros: ['glycolic_acid'],
      manchas: ['glycolic_acid', 'turmeric_bar', 'eye_cream', 'rose_tonic'],
      luminosidad: ['calming_serum'],
      granos: ['black_soap'],
      rojeces: ['calming_serum'],
      lineas: ['anti_aging_serum', 'face_cream'],
      firmeza: ['anti_aging_serum', 'face_cream'],
      flacidez: ['anti_aging_serum', 'face_cream']
    };

    concerns.forEach(c => {
      const products = concernProducts[c] || [];
      products.forEach(key => {
        if (!recommended.includes(key)) {
          recommended.push(key);
        }
      });
    });

    // Si tiene granos: Black Soap como único jabón, quitar productos no compatibles
    if (concerns.includes('granos')) {
      const removeForGranos = ['luna_glow', 'turmeric_bar', 'cleansing_oil', 'sunscreen', 'face_cream', 'elixir_divino', 'hyaluronic_serum'];
      removeForGranos.forEach(key => {
        const idx = recommended.indexOf(key);
        if (idx !== -1) recommended.splice(idx, 1);
      });
      if (!recommended.includes('black_soap')) {
        recommended.unshift('black_soap');
      }
      if (!recommended.includes('calming_serum')) {
        recommended.push('calming_serum');
      }
    }

    // Agregar Contorno de Ojos si la zona incluye contorno de ojos o labios
    if ((answers.faceZone.includes('contorno_ojos') || answers.faceZone.includes('labios')) && !recommended.includes('eye_cream')) {
      recommended.push('eye_cream');
    }

    // Exclusiones por tipo de piel
    const exclusions = {
      joven: ['glycolic_acid', 'anti_aging_serum'],
      sensible: ['glycolic_acid'],
      grasa: ['sunscreen']
    };

    const excluded = exclusions[skin] || [];
    const filtered = recommended.filter(key => !excluded.includes(key));

    // Agregar bloqueador solar a todas menos piel grasa y granos
    if (skin !== 'grasa' && !concerns.includes('granos') && !filtered.includes('sunscreen')) {
      filtered.push('sunscreen');
    }

    // Build product HTML
    const container = document.getElementById('productsContainer');
    let html = '';
    let total = 0;

    filtered.forEach((key, i) => {
      const p = products[key];
      if (!p) return;
      total += p.price;
      html += `
        <div class="ritual-step">
          <div class="product-card">
            <div class="product-image">
              <svg viewBox="0 0 24 24"><rect x="6" y="3" width="12" height="18" rx="2" stroke-width="1"/><path d="M10 3V1h4v2" stroke-width="1"/><path d="M9 10h6M9 13h4" stroke-width="0.8" opacity="0.4"/></svg>
            </div>
            <div class="product-info">
              <div class="product-name">${p.name}</div>
              <div class="product-benefit">${p.benefit}</div>
              <div class="product-bottom">
                <span class="product-price">$${p.price.toFixed(2)}</span>
                <button class="btn-add-ritual" data-product="${key}" onclick="addToRitual(this, '${key}')">Añadir al ritual</button>
              </div>
            </div>
          </div>
        </div>`;
    });

    container.innerHTML = html;
    ritualTotal = total;
    document.getElementById('stickyTotal').textContent = `$${total.toFixed(2)}`;

    // Mostrar Kit 7 Pasos como opción de ahorro si tiene 4+ productos del kit
    const kitProducts = ['cleansing_oil', 'luna_glow', 'rose_tonic', 'vitamin_c_serum', 'anti_aging_serum', 'face_cream', 'eye_cream'];
    const kitMatches = filtered.filter(k => kitProducts.includes(k)).length;
    // La caja del Kit es opcional: si no está en la sección, se sigue sin error
    const kitSection = document.getElementById('kitSection');
    if (kitSection) kitSection.style.display = kitMatches >= 4 ? '' : 'none';

    // ── LIFESTYLE TIPS ──────────────────────────────
    const lifestyleTips = {
      water: {
        poca: { label: 'Hidratación', text: 'Tu piel muchas veces refleja lo que falta adentro. Cuando el agua no es suficiente, puede verse más opaca, tirante o sin vitalidad. Empieza poco a poco — más que obligarte, crea un ritual simple: un vaso al despertar, otro a media mañana y otro en la tarde. La hidratación constante transforma la piel desde la raíz.' },
        suficiente: { label: 'Hidratación', text: 'Tu piel agradece ese hábito silencioso que sostiene elasticidad, luminosidad y equilibrio. Vas por muy buen camino. Mantén la constancia y acompaña ese hábito con minerales, frutas ricas en agua y una rutina que ayude a sellar esa hidratación en la piel.' },
        mucha: { label: 'Hidratación', text: 'La hidratación interna es una gran aliada, pero recuerda que la piel también necesita saber retener esa agua. Más que aumentar la cantidad, enfócate en fortalecer la barrera de la piel con hábitos que ayuden a conservar esa hidratación: descanso, nutrición y texturas que sellen con confort. El agua no solo hidrata — también enseña a la piel a recuperar su brillo natural cuando hay constancia.' }
      },
      outdoor: {
        casi_nunca: { label: 'Aire Libre', text: 'La piel también necesita respirar a través de tus hábitos. Permanecer siempre en espacios cerrados puede apagar la luminosidad natural y aumentar la sensación de fatiga en el rostro. Regálale a tu piel pequeños momentos de exterior: una caminata corta, luz natural en la mañana o unos minutos de sol suave. El contacto con el aire libre mejora la circulación, la oxigenación y el bienestar en general.' },
        a_veces: { label: 'Aire Libre', text: 'Tu piel ya recibe algunos beneficios del exterior, pero aún puede ganar más vitalidad cuando este hábito se vuelve parte de tu rutina. Haz del aire libre un ritual consciente — incluso 10 o 15 minutos al día de luz natural, movimiento y respiración profunda pueden marcar una diferencia en tono, brillo y energía.' },
        frecuentemente: { label: 'Aire Libre', text: 'Tu piel recibe uno de los mejores regalos: oxígeno, movimiento y conexión con la naturaleza. Sigue sosteniendo ese hábito y acompáñalo con protección solar diaria.' }
      },
      stress: {
        bajo: { label: 'Estrés', text: 'Tu piel se beneficia enormemente de un sistema nervioso en calma. Cuando el estrés está regulado, la piel suele verse más luminosa, más uniforme y estable. Sigue protegiendo esos espacios de bienestar: la respiración, el descanso, los movimientos suaves y las pausas son parte de la belleza real que se refleja en tu piel.' },
        moderado: { label: 'Estrés', text: 'La piel puede empezar a mostrar pequeñas señales: cansancio, opacidad, sensibilidad o cambios en textura. Más que esperar a sentirte saturada, incorpora mini pausas durante el día — incluso cinco minutos de respiración consciente, caminar o desconectarte de pantallas ayuda a que la piel no cargue ese ritmo interno.' },
        alto: { label: 'Estrés', text: 'Tu piel no solo necesita cuidado externo — también necesita que tu cuerpo reciba señales de seguridad. Prioriza el sueño, las pausas reales, la respiración profunda y los rituales nocturnos que le enseñen a tu sistema a bajar el ritmo. Recuerda que la piel escucha todo lo que tu sistema nervioso vive. Cuando recuperas la calma, recuperas la luz.' }
      },
      sleep: {
        poco: { label: 'Sueño', text: 'La piel suele ser una de las primeras en mostrar la falta de descanso: tono apagado, más líneas marcadas, inflamación y pérdida de frescura. Más que pensar solo en horas, crea una rutina nocturna que le enseñe al cuerpo a entrar en descanso — bajar luces, menos pantalla, respiración y un ritual de cuidado que le dé una señal de cierre del día.' },
        irregular: { label: 'Sueño', text: 'Tu piel recibe parte del beneficio, pero la irregularidad puede reflejarse en días donde te sientes más cansada o menos uniforme. La clave está en la constancia. Intenta sostener horarios similares y pequeños rituales antes de dormir para que la regeneración nocturna se vuelva más profunda y visible en la piel.' },
        profundo: { label: 'Sueño', text: 'Te estás regalando a tu piel uno de los mejores tratamientos naturales: tiempo real de reparación. Sigue honrando ese hábito. Durante el sueño profundo, la piel se renueva, recupera luminosidad y fortalece su barrera — por eso se refleja en una apariencia más descansada y viva. La noche no solo descansa la mente, también reconstruye la piel.' }
      }
    };

    const tipsContainer = document.getElementById('lifestyleTipsContainer');
    let tipsHTML = '';

    if (answers.lifestyleWater && lifestyleTips.water[answers.lifestyleWater]) {
      const tip = lifestyleTips.water[answers.lifestyleWater];
      tipsHTML += `<div class="lifestyle-tip"><div class="lifestyle-tip-label">${tip.label}</div><div class="lifestyle-tip-text">${tip.text}</div></div>`;
    }
    if (answers.lifestyleOutdoor && lifestyleTips.outdoor[answers.lifestyleOutdoor]) {
      const tip = lifestyleTips.outdoor[answers.lifestyleOutdoor];
      tipsHTML += `<div class="lifestyle-tip"><div class="lifestyle-tip-label">${tip.label}</div><div class="lifestyle-tip-text">${tip.text}</div></div>`;
    }
    if (answers.lifestyleStress && lifestyleTips.stress[answers.lifestyleStress]) {
      const tip = lifestyleTips.stress[answers.lifestyleStress];
      tipsHTML += `<div class="lifestyle-tip"><div class="lifestyle-tip-label">${tip.label}</div><div class="lifestyle-tip-text">${tip.text}</div></div>`;
    }
    if (answers.lifestyleSleep && lifestyleTips.sleep[answers.lifestyleSleep]) {
      const tip = lifestyleTips.sleep[answers.lifestyleSleep];
      tipsHTML += `<div class="lifestyle-tip"><div class="lifestyle-tip-label">${tip.label}</div><div class="lifestyle-tip-text">${tip.text}</div></div>`;
    }

    // Consejos de clima
    tipsContainer.innerHTML = tipsHTML;
  }

  // ── ADD TO RITUAL ──────────────────────────────
  window._addToRitual_REPLACED = function(btn, key) {  // replaced below
    btn.textContent = 'Añadido';
    btn.classList.add('added');
    ritualCart.add(key);
  };

  window._addAllToCart_REPLACED = function() {  // replaced below
    document.querySelectorAll('.btn-add-ritual').forEach(btn => {
      btn.textContent = 'Añadido';
      btn.classList.add('added');
      ritualCart.add(btn.dataset.product);
    });
    const stickyBtn = document.getElementById('stickyBarBtn');
    stickyBtn.textContent = 'Añadido al carrito';
    stickyBtn.style.background = 'var(--sage)';
    stickyBtn.style.color = 'var(--green)';
  };

  window._addKitToCart_REPLACED = function() {  // replaced below
    ritualCart.add('kit_7');
    alert('Kit 7 Pasos añadido al carrito');
  };

  window.restartQuiz = function() {
    // Reset answers
    Object.keys(answers).forEach(k => {
      if (Array.isArray(answers[k])) answers[k] = [];
      else answers[k] = null;
    });

    // Reset UI
    document.querySelectorAll('.card.selected').forEach(c => c.classList.remove('selected'));
    document.querySelectorAll('.pill.selected').forEach(p => p.classList.remove('selected'));
    document.querySelectorAll('.visual-box.selected').forEach(v => v.classList.remove('selected'));
    document.querySelectorAll('.card.disabled').forEach(c => c.classList.remove('disabled'));

    // Reset buttons
    for (let i = 1; i <= 8; i++) {
      const btn = document.getElementById('btnStep' + i);
      if (btn && i !== 7) btn.disabled = true;
    }

    // Reset form
    document.getElementById('userName').value = '';
    document.getElementById('userEmail').value = '';

    // Reset cart
    ritualCart.clear();
    ritualTotal = 0;

    // Hide sticky bar
    document.getElementById('stickyBar').classList.remove('visible');

    // Reset sticky btn
    const stickyBtn = document.getElementById('stickyBarBtn');
    stickyBtn.style.background = '';
    stickyBtn.style.color = '';

    goToStep(0);
  };

  // ── KEYBOARD SUPPORT ───────────────────────────
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      const el = document.activeElement;
      if (el && (el.classList.contains('card') || el.classList.contains('pill') || el.classList.contains('visual-box'))) {
        e.preventDefault();
        el.click();
      }
    }
  });


  // ── SHOPIFY VARIANT MAP ────────────────────────
  // Variantes por producto: las escribe sections/tm-skin-analysis.liquid desde Shopify
  var VARIANT_MAP = window.tmQuizVariantes || {};

  function avisarCarrito(abrir) {
    // Con carrito lateral (theme nuevo): assets/cart-drawer.js lo actualiza y lo abre si abrir = true.
    // Sin carrito lateral (theme anterior): "ver carrito" lleva a la página del carrito.
    if (document.querySelector('[data-tm-carrito]')) {
      document.dispatchEvent(new CustomEvent('tm:carrito-actualizado', { detail: { abrir: abrir } }));
    } else if (abrir) {
      window.location.href = (window.tmRutas && window.tmRutas.raiz) || '/cart';
    }
  }

  function agregar(keys) {
    const items = keys
      .filter((k) => VARIANT_MAP[k])
      .map((k) => ({ id: VARIANT_MAP[k], quantity: 1 }));
    if (!items.length) return Promise.reject(new Error('Producto no disponible'));
    const ruta = (window.tmRutas && window.tmRutas.agregar) || '/cart/add';
    return fetch(`${ruta}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then((r) => r.json().then((json) => {
      if (!r.ok) throw new Error(json.description || 'No se pudo añadir');
      return json;
    }));
  }

  function marcarAnadido(btn) {
    btn.textContent = 'Añadido';
    btn.classList.add('added');
    btn.disabled = false;
    ritualCart.add(btn.dataset.product);
  }

  window.addToRitual = function(btn, key) {
    if (btn.classList.contains('added')) {
      avisarCarrito(true);
      return;
    }
    btn.dataset.product = btn.dataset.product || key;
    btn.disabled = true;
    btn.textContent = 'Añadiendo…';
    agregar([key])
      .then(() => {
        marcarAnadido(btn);
        avisarCarrito(false);
      })
      .catch(() => {
        btn.disabled = false;
        btn.textContent = VARIANT_MAP[key] ? 'Reintentar' : 'No disponible';
      });
  };

  window.addAllToCart = function() {
    const stickyBtn = document.getElementById('stickyBarBtn');
    const pendientes = Array.from(document.querySelectorAll('.btn-add-ritual')).filter((b) => !b.classList.contains('added'));
    const terminar = () => {
      stickyBtn.disabled = false;
      stickyBtn.textContent = '✓ Ver mi carrito';
      stickyBtn.style.background = 'var(--sage)';
      stickyBtn.style.color = 'var(--green)';
      avisarCarrito(true);
    };
    if (!pendientes.length) {
      terminar();
      return;
    }
    stickyBtn.disabled = true;
    stickyBtn.textContent = 'Añadiendo…';
    agregar(pendientes.map((b) => b.dataset.product))
      .then(() => {
        pendientes.forEach(marcarAnadido);
        terminar();
      })
      .catch(() => {
        // Si uno falla, Shopify rechaza todo el pedido: se añaden uno por uno
        pendientes
          .reduce((cadena, btn) => cadena.then(() => agregar([btn.dataset.product])
            .then(() => marcarAnadido(btn))
            .catch(() => { btn.textContent = 'No disponible'; })), Promise.resolve())
          .then(() => {
            if (document.querySelector('.btn-add-ritual.added')) {
              terminar();
            } else {
              stickyBtn.disabled = false;
              stickyBtn.textContent = 'No pudimos añadirlos · Reintentar';
            }
          });
      });
  };

  window.addKitToCart = function() {
    agregar(['kit_7']).then(() => avisarCarrito(true)).catch(() => {});
  };


  window.submitEmail = function() {
    answers.name = document.getElementById('userName').value.trim();
    answers.email = document.getElementById('userEmail').value.trim();
    if (answers.email) {
      fetch('/contact', {
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        body: new URLSearchParams({
          'form_type': 'customer',
          'contact[email]': answers.email,
          'contact[tags]': 'skin_quiz,' + (answers.skinType || 'unknown'),
          'utf8': '✓'
        })
      }).catch(function() {});
    }
    showResults();
  };

  // ── INIT ───────────────────────────────────────
  updateUI();

})();
